// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3BUCC","label":"Radio_label__3MJU7","checkMark":"Radio_checkMark__1VqPs","disabled":"Radio_disabled__SVtqV"};